import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import { ShareDialog } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { open, url, shortURL } = state.shareDialog
  const { language } = state.user
  return ({
    open,
    url,
    shortURL,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClose: () => dispatch(actions.shareDialog.close()),
    handleEnter: (url) => {
      ownProps.onEnter()
    },
    handleEntering: (url) => () => {
      dispatch(api.bitly.fetchMakeShortURL(url))
    },
    handleExited: () => dispatch(api.bitly.clearShortURL()),
    notify: (message) => dispatch(actions.snackbar.notify(message)),
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShareDialog)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/ShareDialog.js